/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';
import TopKolam from '@components/Headings/TopKolam';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import { useMediaQuery } from 'react-responsive';
/* Internal Imports */
/* Components */

/**
 *
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @param sectionContent.width
 * @param sectionContent.height
 * @param sectionContent.my
 * @param sectionContent.display
 * @param sectionContent.maxW
 * @returns {ReactElement} ImageBannerAd component
 */
const PastPartners = ({
    section, region, language
}) => {
    // debugger;
    const isMobile = useMediaQuery({ maxWidth: 767 });


    return (
        <Box
            width={"100%"}
            // height={{ base: "677px", sm: "677px", lg: "515px" }}
            padding={{ base: "40px 0px", sm: "40px 0px", lg: "80px 0" }}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
        >
            <Box display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
            >
                <Box
                    position={"relative"}
                >
                    <Box
                        fontSize={{ base: "30px", sm: "30px", lg: "30px" }}
                        fontWeight={"semibold"}
                        color={"#000000"}
                        width={{ base: "250px", sm: "250px", lg: "100%" }}
                        textAlign={"center"}
                    >
                        {section?.sectionContent[0]?.titleText}
                    </Box>
                    <Box position={"absolute"} top={{ base: "75px", sm: "75px", lg: "30px" }} left={{ base: "45px", sm: "45px", lg: "70px" }}>
                        <TopKolam sectionContent={section?.sectionContent[1]} />
                    </Box>
                </Box>

                <Box
                    marginTop={{ sm: "50px", base: "50px", lg: "57px" }}
                    display={"flex"}
                    flexDirection={{ sm: "column", base: "column", lg: "row" }}
                    alignItems={"center"}
                >
                    {[2, 3, 4].map((index) => (
                        <LazyLoadImageComponent
                            key={index}
                            height={"224px"}
                            alt={isMobile ? (section?.sectionContent[index]?.mobileImage?.alt || section?.sectionContent[index]?.mobileImage?.alt) : section?.sectionContent[index]?.image?.alt}
                            title={isMobile ? (section?.sectionContent[index]?.mobileImage?.title || section?.sectionContent[index]?.mobileImage?.title) : section?.sectionContent[index]?.image?.url}
                            src={isMobile ? (section?.sectionContent[index]?.mobileImage?.url || section?.sectionContent[index]?.mobileImage?.url) : section?.sectionContent[index]?.image?.url}
                        />
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default PastPartners;
